import { render } from "./StatusBar.vue?vue&type=template&id=6ac82214"
import script from "./StatusBar.vue?vue&type=script&lang=js"
export * from "./StatusBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/lockstep/StatusBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ac82214"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ac82214', __exports__)) {
    api.reload('6ac82214', __exports__)
  }
  
  module.hot.accept("./StatusBar.vue?vue&type=template&id=6ac82214", () => {
    api.rerender('6ac82214', render)
  })

}


export default __exports__